import { FunctionComponent } from 'react';
import classnames from 'classnames';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutSectionsBlocTwoCol: FunctionComponent<Props> = ({
    direction,
    leftCol,
    rightCol,
}) => {
    return (
        <StyledComponent
            className={classnames(
                'public-layout-sections-blocks-two-col',
                `direction-${direction}`
            )}
        >
            <div className="left-col">
                {leftCol}
            </div>
            <div className="right-col">
                {rightCol}
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutSectionsBlocTwoCol;